export const USER_GROUP_VALUES = {
  LOGGED_CUSTOMER: 'LOGGEDCUSTOMER',
  LOGGED_MERCHANT: 'LOGGEDMERCHANT',
  LOGGED_STAFF: 'LOGGEDSTAFF',
  NOT_LOGGED: 'NOTLOGGED',
}

export const USER_GROUP_NAME = 'user_type'
